import './Text.tailwind.css';

export type CounterProps = {
  children?: JSX.Element | string;
};

export const Counter = ({ children }: CounterProps) => (
  <h3 className="counter text-[72px]">{children}</h3>
);
